import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const url = state.url;
    // Skip auth check for /booking route
    if (url.startsWith('/booking')) {
      return true;
    }
    const isAuth = localStorage.getItem('pulse-right') || null;

    // If not authenticated, redirect to login
    if (!isAuth) {
      await this.router.navigate(['/login-admin']);
      return false;
    }

    // Default: allow navigation
    return true;
  }
}
